import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

function setQuantity(form, target) {
  if (!form) return;
  var input = form.querySelector('input[name="quantity"]');
  if (!input) return;
  var current = parseInt(input.value, 10) || 1;
  if (current === target) return;
  var plus = form.querySelector('button[name="plus"]');
  var minus = form.querySelector('button[name="minus"]');
  var guard = 0;
  while (current < target && plus && guard < 20) {
    plus.click();
    current++;
    guard++;
  }
  while (current > target && minus && guard < 40) {
    minus.click();
    current--;
    guard++;
  }
  input.value = target;
  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.dispatchEvent(new Event('change', { bubbles: true }));
}

function getCartSectionIds() {
  var ids = [];
  document.querySelectorAll('cart-items-component').forEach(function (el) {
    if (el.dataset.sectionId && ids.indexOf(el.dataset.sectionId) === -1) {
      ids.push(el.dataset.sectionId);
    }
  });
  return ids;
}

/**
 * Adds the warranty variant as its own cart line, then dispatches the same
 * CartLinesUpdateEvent the theme's own add-to-cart flow uses so the cart
 * drawer/page refresh and show it without needing a manual reload.
 */
function addWarrantyItem(variantId) {
  var sectionIds = getCartSectionIds();
  var deferred = CartLinesUpdateEvent.createPromise();

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      items: [{ id: variantId, quantity: 1 }],
      sections: sectionIds.join(','),
      sections_url: window.location.pathname,
    }),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      if (data.status) {
        deferred.reject(new Error(data.message || 'Add to cart failed'));
        return;
      }
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(data),
        detail: {
          sections: data.sections,
          items: data.items,
          source: 'luxshock-bundle-select',
          didError: false,
        },
      });
    })
    .catch(function (error) {
      deferred.reject(error);
    });
}

function init() {
  var selector = document.querySelector('[data-lx-bundle]');
  var form = document.querySelector('product-form-component form') || document.querySelector('form[action*="/cart/add"]');

  if (selector) {
    var options = selector.querySelectorAll('.lx-bsel__opt');
    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) {
          o.classList.remove('is-active');
        });
        opt.classList.add('is-active');
        opt.querySelector('input').checked = true;
        setQuantity(form, parseInt(opt.dataset.qty, 10));
      });
    });
  }

  document.querySelectorAll('[data-lx-warranty-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var checkbox = toggle.querySelector('input[type="checkbox"]');
      if (!checkbox) return;
      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  var warrantyBox = document.querySelector('[data-lx-warranty]');
  if (!warrantyBox || !form) return;

  var pendingWarrantyVariantId = null;

  form.addEventListener('submit', function () {
    pendingWarrantyVariantId = warrantyBox.checked ? warrantyBox.getAttribute('data-variant-id') : null;
  });

  // Wait for the theme's own add-to-cart request (and its cart/drawer render)
  // to finish before adding the warranty line, so both end up reflected in
  // the same UI update instead of racing two separate cart mutations.
  document.addEventListener(StandardEvents.cartLinesUpdate, function (event) {
    if (!pendingWarrantyVariantId) return;
    var variantId = pendingWarrantyVariantId;
    pendingWarrantyVariantId = null;

    event.promise
      ?.then(function () {
        addWarrantyItem(variantId);
      })
      .catch(function () {});
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
